export default __webpack_public_path__ + "static/media/Van27.aba49b28.webp";